import { coordsToSegments, planLineStyle } from "helpers/map";
import { divIcon } from "leaflet";
import React, { useEffect, useState } from "react";
import { Marker, Polyline } from "react-leaflet";

const DistrtibutionBidRoute = ({ distributionBidRoute, changeMapPosition, showTollRoads }) => {
    const [route, setRoute] = useState(null);
    const [supportPoints, setSupportPoints] = useState(null);
    const [tollSegments, setTollSegments] = useState([]);

    useEffect(() => {
        const { totalRoute, supportPoints, tollSegments } = coordsToSegments(
            distributionBidRoute.segments,
            distributionBidRoute.tollRoadSegments,
        );
        setRoute(totalRoute);
        setSupportPoints(supportPoints);
        setTollSegments(tollSegments);
        changeMapPosition(totalRoute);
    }, [changeMapPosition, distributionBidRoute]);

    if (!route) {
        return null;
    }

    const renderSupportPoints = () => {
        const props = {
            icon: divIcon({ className: "route-icon route-icon--between", iconSize: [15, 15] }),
        };
        const pointRenderer = (point, index) => <Marker key={index} position={point} {...props} />;

        return supportPoints.map(pointRenderer);
    };
    return (
        <>
            <Polyline positions={route} {...planLineStyle} />
            {showTollRoads &&
                tollSegments.map((segment) => (
                    <Polyline
                        key={`${segment.segmentId}_${segment.startIndex}_${segment.endIndex}`}
                        positions={segment.positions}
                        weight={5}
                        color={segment.color}
                    />
                ))}
            {renderSupportPoints()}
        </>
    );
};

export default DistrtibutionBidRoute;
